define([
], function (
) {
    'use strict';

    function move(ref, to, from) {
        if (!get(from, ref)) {
            return;
        }

        if (!get(to, ref)) {
            set(to, ref, get(from, ref));
        }
        remove(from, ref);
    }

    function get(parentData, ref) {
        return ref && parentData[ref.replace('#', '')];
    }

    function set(parentData, ref, dataToSet) {
        if (ref) {
            parentData[ref.replace('#', '')] = dataToSet;
        }
    }

    function remove(parentData, ref) {
        if (ref) {
            delete parentData[ref.replace('#', '')];
        }
    }

    function moveMediaRef(parentData, mediaRef, masterData) {
        // Image or WixVideo
        const media = get(parentData, mediaRef);
        if (!media) {
            return;
        }

        move(mediaRef, masterData, parentData);
        // Image
        move(media.posterImageRef, masterData, parentData);
    }

    function moveBgMedia(pageId, bgImage, masterPageData, pageData, sendBiError) {
        if (bgImage) {
            if (bgImage.mediaRef) {
                moveMediaRef(pageData, bgImage.mediaRef, masterPageData);
            }
            //Image
            move(bgImage.imageOverlay, masterPageData, pageData);
        } else {
            sendBiError(pageId);
        }
    }

    const movePageDataToMaster = (page, masterPage, sendBiError) => {
        if (!page.structure) {
            return;
        }

        function movePageBackgroundData(pageId, pageData, masterData) {
            let desktopBg;
            let mobileBg;

            // Pages or AppPages
            const pageItem = get(pageData, pageId);
            move(pageId, masterData, pageData);

            if (pageItem && pageItem.pageBackgrounds && pageItem.pageBackgrounds.desktop.ref) {
                // Return if backgroundImage is already present on masterPage document data
                const masterPageDesktopBg = get(masterData, pageItem.pageBackgrounds.desktop.ref);
                if (masterPageDesktopBg) {
                    return;
                }
                // BackgroundImage or BackgroundMedia
                desktopBg = get(pageData, pageItem.pageBackgrounds.desktop.ref);
                mobileBg = get(pageData, pageItem.pageBackgrounds.mobile.ref);
                move(pageItem.pageBackgrounds.desktop.ref, masterData, pageData);
                move(pageItem.pageBackgrounds.mobile.ref, masterData, pageData);

                //BackgroundMedia
                moveBgMedia(pageItem.id, desktopBg, masterData, pageData, sendBiError);
                moveBgMedia(pageItem.id, mobileBg, masterData, pageData, sendBiError);
            }
        }

        const masterPageDocumentData = masterPage.data.document_data;
        const pageDocumentData = page.data.document_data;
        const pageId = page.structure.id;

        movePageBackgroundData(pageId, pageDocumentData, masterPageDocumentData);
        if (masterPage.translations && page.translations) {
            const languages = Object.keys(page.translations);
            languages.forEach(language => {
                if (masterPage.translations[language]) {
                    const translatedPage = page.translations[language].data.document_data;
                    const masterTranslationData = masterPage.translations[language].data.document_data;
                    const translatedElements = Object.assign({}, masterPage.data.document_data, translatedPage);
                    movePageBackgroundData(pageId, translatedElements, masterTranslationData);
                }
            });
        }
    };

    const movePageDataFromMaster = (page, masterPage, sendBiError) => {
        if (!page.structure) {
            return;
        }

        function movePageBackgroundData(pageId, pageData, masterData) {
            let desktopBg;
            let mobileBg;

            // Pages or AppPages
            const pageItem = get(masterData, pageId);
            move(pageId, pageData, masterData);

            if (pageItem && pageItem.pageBackgrounds && pageItem.pageBackgrounds.desktop.ref) {
                // Return if backgroundImage is already present on masterPage document data
                const pageDesktopBg = get(pageData, pageItem.pageBackgrounds.desktop.ref);
                if (pageDesktopBg) {
                    return;
                }
                // BackgroundImage or BackgroundMedia
                desktopBg = get(masterData, pageItem.pageBackgrounds.desktop.ref);
                mobileBg = get(masterData, pageItem.pageBackgrounds.mobile.ref);
                move(pageItem.pageBackgrounds.desktop.ref, pageData, masterData);
                move(pageItem.pageBackgrounds.mobile.ref, pageData, masterData);

                //BackgroundMedia
                moveBgMedia(pageItem.id, desktopBg, pageData, masterData, 'MISSING_DESKTOP_BACKGROUND_ITEM', sendBiError);
                moveBgMedia(pageItem.id, mobileBg, pageData, masterData, 'MISSING_MOBILE_BACKGROUND_ITEM', sendBiError);
            }
        }

        const masterPageDocumentData = masterPage.data.document_data;
        const pageDocumentData = page.data.document_data;
        const pageId = page.structure.id;
        movePageBackgroundData(pageId, pageDocumentData, masterPageDocumentData);
        if (masterPage.translations && page.translations) {
            const languages = Object.keys(page.translations);
            languages.forEach(language => {
                if (masterPage.translations[language]) {
                    const translatedPage = page.translations[language].data.document_data;
                    const masterTranslationData = masterPage.translations[language].data.document_data;
                    const translatedElements = Object.assign({}, masterPage.data.document_data, translatedPage);
                    movePageBackgroundData(pageId, translatedElements, masterTranslationData);
                }
            });
        }
    };
    const getDataPointer = (pageId, dataId) => ({pageId, path: ['data', 'document_data', dataId.replace('#', '')]});

    const getPageBackgroundDataPointers = (page, pageIds) => {
        const dataMap = page.data.document_data;
        const dataIds = pageIds.slice().map(pageId => getDataPointer(pageId, pageId));
        return dataIds.reduce((allIds, {pageId}) => {
            const addDataItem = id => dataIds.push(getDataPointer(pageId, id));
            const pageDataItem = get(dataMap, pageId);
            if (pageDataItem && pageDataItem.pageBackgrounds && get(dataMap, pageDataItem.pageBackgrounds.desktop.ref)) {
                const desktopBg = get(dataMap, pageDataItem.pageBackgrounds.desktop.ref);
                const mobileBg = get(dataMap, pageDataItem.pageBackgrounds.mobile.ref);
                [desktopBg, mobileBg].forEach(bg => {
                    if (bg) {
                        addDataItem(bg.id);
                        if (bg.mediaRef) {
                            addDataItem(bg.mediaRef);
                            const mediaItem = get(dataMap, bg.mediaRef);
                            if (mediaItem && mediaItem.posterImageRef) {
                                addDataItem(mediaItem.posterImageRef);
                            }
                        }
                        if (bg.imageOverlay) {
                            addDataItem(bg.imageOverlay);
                        }
                    }
                });
            }
            return allIds;
        }, dataIds);
    };

    return {
        getPageBackgroundDataPointers,
        movePageDataToMaster,
        movePageDataFromMaster
    };
});
